import { RAHeadItemProps } from './types';
import { Avatar, Box, Icon, IconButton, Typography } from '@mui/material';
import FormattedMessage from 'app/design/uiComponents/FormattedMessage';
import MuiButton from 'app/design/uiComponents/MuiButton';

const RAHeadItem = ({
  isSeeAll,
  category,
  fullWidth,
  handleClick,
  isAuthorPage = false,
}: RAHeadItemProps) => {
  return (
    <Box
      className="p-main-spacing"
      sx={{
        py: 2,
        display: { md: 'flex' },
        flexDirection: { md: 'column' },
        alignItems: { md: fullWidth ? 'initial' : 'flex-start' },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        sx={{ display: { xs: 'flex', md: 'flex' } }}
      >
        {
          <Box sx={{ mr: 2, order: { md: 0 } }}>
            <Avatar
              src={
                category.ra_image
                  ? `data:image/png;base64,${category.ra_image}`
                  : undefined
              }
              alt={category.ra_name || 'Author'}
              sx={{
                width: isAuthorPage ? 150 : 100,
                height: isAuthorPage ? 150 : 100,
                cursor: isSeeAll ? 'pointer' : 'default',
              }}
              {...(isSeeAll && {
                onClick: handleClick as () => void,
              })}
            >
              {!category.ra_image &&
                category.ra_name &&
                category.ra_name.charAt(0).toUpperCase()}
            </Avatar>
          </Box>
        }
        <Box className="p-main-spacing" sx={{ flex: 1, order: { md: 1 } }}>
          {category.ra_name && (
            <Typography
              variant="h5"
              fontWeight={800}
              color="text.primary"
              sx={{
                flex: 1,
                order: { md: 1 },
                cursor: isSeeAll ? 'pointer' : 'default',
              }}
              {...(isSeeAll && {
                onClick: handleClick as () => void,
              })}
            >
              {category.ra_name}
            </Typography>
          )}
          {category.ra_sebi_reg_no && (
            <Typography
              variant="body1"
              fontWeight={500}
              color="text.primary"
              sx={{
                flex: 1,
                order: { md: 1 },
                cursor: isSeeAll ? 'pointer' : 'default',
              }}
              {...(isSeeAll && {
                onClick: handleClick as () => void,
              })}
            >
              {category?.ra_sebi_reg_no}
            </Typography>
          )}
          {category.ra_bots && (
            <Typography
              variant="body1"
              fontWeight={500}
              color="text.primary"
              sx={{
                flex: 1,
                order: { md: 1 },
                cursor: isSeeAll ? 'pointer' : 'default',
              }}
              {...(isSeeAll && {
                onClick: handleClick as () => void,
              })}
            >
              Total Bots : {category?.ra_bots.length}{' '}
            </Typography>
          )}
        </Box>
      </Box>

      {category.ra_description && category?.ra_description != '<p><br></p>' && (
        <Typography
          variant="body1"
          // fontWeight={200}
          // fontSize="1rem"
          color="text.primary"
          sx={
            !isAuthorPage
              ? {
                  cursor: isSeeAll ? 'pointer' : 'default',
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }
              : {
                  flex: 1,
                  order: { md: 1 },
                  cursor: isSeeAll ? 'pointer' : 'default',
                }
          }
          dangerouslySetInnerHTML={{
            // eslint-disable-next-line @typescript-eslint/naming-convention
            __html: category?.ra_description,
          }}
          {...(isSeeAll && {
            onClick: handleClick as () => void,
          })}
        ></Typography>
      )}
      {category.ra_address &&
        category.ra_address.city &&
        category.ra_address.state && (
          <Typography
            variant="body3"
            sx={{
              mt: { xs: 1, md: 2 },
              order: { md: 2 },
              maxWidth: fullWidth ? 'lg' : '100%',
            }}
            color="text.secondary"
          >
            {category.ra_address.city + ', ' + category?.ra_address.state}
          </Typography>
        )}
      {category.ra_social_media_links && (
        <Typography
          variant="body3"
          sx={{
            mt: { xs: 1, md: 2 },
            order: { md: 2 },
            maxWidth: fullWidth ? 'lg' : '100%',
          }}
          color="text.secondary"
        >
          {category.ra_social_media_links &&
            (
              category.ra_social_media_links as Array<Record<string, string>>
            ).map(res => (
              <MuiButton
                variant="contained"
                key={res.social_media_platform_name}
                size="small"
                color="secondary"
                sx={{ order: { md: 3 }, mt: { md: fullWidth ? 0 : 0 } }}
                onClick={() => {
                  window.open(res.social_media_profile_url, '_blank');
                }}
              >
                <img
                  src={`data:image/png;base64,${res.social_media_icon}`}
                  alt={res ? res.social_media_platform_name : ''}
                  style={{ marginRight: 1 }}
                  height="24px"
                />
              </MuiButton>
            ))}
        </Typography>
      )}
      {category.description && (
        <Typography
          variant="body3"
          sx={{
            mt: { xs: 1, md: 2 },
            order: { md: 2 },
            maxWidth: fullWidth ? 'lg' : '100%',
          }}
          color="text.secondary"
        >
          {category.description}
        </Typography>
      )}
      {isSeeAll && (
        <MuiButton
          variant="contained"
          size="small"
          color="secondary"
          sx={{ order: { md: 3 }, mt: { md: fullWidth ? 0 : 2 } }}
          {...(isSeeAll && {
            onClick: handleClick as () => void,
          })}
        >
          <FormattedMessage id="buttons.see_all" />
        </MuiButton>
      )}
    </Box>
  );
};

export default RAHeadItem;
